module.exports = __webpack_public_path__ + "img/swab2_7-8-2021.cb90b5e2.jpg";